import React from 'react';
import HomeLayout from './layouts/HomeLayout';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import ArsenalArmiesPageMake from './pages/arsenal/ArsenalArmiesPageMake';
import MagicPathSpellsPageIndex from './pages/ninthage/MagicPathSpellsPageIndex';
import UserProfilPageIndex from './pages/user/UserProfilPageIndex';
import ArmyListsPageIndex from './pages/builder/ArmyListsPageIndex';
import ArmyListPageMake from './pages/builder/ArmyListPageMake';
import MyFolderPageShow from './pages/builder/MyFolderPageShow';
import MyContestPageMake from './pages/tournament/MyContestPageMake';
import ArmyListUnitPageShow from './pages/builder/ArmyListUnitPageShow';
import SearchArmyListPage from './pages/builder/SearchArmyListPage';
import SearchModelRulePage from './pages/ninthage/SearchModelRulePage';
import DraftPageNew from './pages/tool/draft/DraftPageNew';
import DraftTeamPageMake from './pages/tool/draft/DraftTeamPageMake';
import DraftTeamPageNew from './pages/tool/draft/DraftTeamPageNew';
import ToolSurveyUnitPageMake from './pages/tool/survey/ToolSurveyUnitPageMake';
import ToolSurveyPageIndex from './pages/tool/survey/ToolSurveyPageIndex';
import ToolSurveyPageShow from './pages/tool/survey/ToolSurveyPageShow';
import ToolSurveyPageResult from './pages/tool/survey/ToolSurveyPageResult';
import PublicationBookPageIndex from './pages/publication/publication-book.page.index';
import PublicationBookPageMake from './pages/publication/publication-book.page.make';
import FederationClubPageIndex from './pages/federation/FederationClubPageIndex';
import * as Sentry from '@sentry/react';
import MapPageShow from './pages/ninthage/table/map.page.show';
import MapPageIndex from './pages/ninthage/table/map.page.index';
import PublicationArmyBookPageMake from './pages/publication/publication-army-book.page.make';
import PublicationArmyBookPageNew from './pages/publication/publication-army-book.page.new';

const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);

const AppRouter = () => {
  return (
    <BrowserRouter>
      <SentryRoutes>
        <Route path="/:lang/arsenal/armies" element={<HomeLayout />}>
          <Route path="/:lang/arsenal/armies/:id" element={<ArsenalArmiesPageMake />} />
        </Route>

        <Route path="/:lang/ninth-age/magic-paths" element={<HomeLayout />}>
          <Route index element={<MagicPathSpellsPageIndex />} />
          <Route path="/:lang/ninth-age/magic-paths/:magic_path_id" element={<MagicPathSpellsPageIndex />} />
        </Route>

        <Route path="/:lang/profile/me" element={<HomeLayout />}>
          <Route index element={<UserProfilPageIndex />} />
        </Route>

        <Route path="/:lang/builder/army_lists" element={<HomeLayout />}>
          <Route index element={<ArmyListsPageIndex />} />
          <Route path="/:lang/builder/army_lists/:army_list_id" element={<ArmyListPageMake />} />
        </Route>
        <Route path="/:lang/builder/searchs" element={<HomeLayout />}>
          <Route index element={<SearchArmyListPage />} />
        </Route>

        <Route path="/:lang/builder/army_list_units" element={<HomeLayout />}>
          <Route path="/:lang/builder/army_list_units/:army_list_unit_id" element={<ArmyListUnitPageShow />} />
        </Route>

        <Route path="/:lang/builder/folders" element={<HomeLayout />}>
          <Route path="/:lang/builder/folders/:folder_id" element={<MyFolderPageShow />} />
        </Route>
        <Route path="/:lang/tool/search_rules" element={<HomeLayout />}>
          <Route index element={<SearchModelRulePage />} />
        </Route>

        <Route path="/:lang/tournament/my_contest" element={<HomeLayout />}>
          <Route path="/:lang/tournament/my_contest/:contest_id" element={<MyContestPageMake />} />
        </Route>

        <Route path="/:lang/tool/pairing/drafts/new" element={<HomeLayout />}>
          <Route path="/:lang/tool/pairing/drafts/new" element={<DraftPageNew />} />
        </Route>

        <Route path="/:lang/tool/pairing/teams" element={<HomeLayout />}>
          <Route path="/:lang/tool/pairing/teams/:team_id/new" element={<DraftTeamPageNew />} />
          <Route path="/:lang/tool/pairing/teams/:team_id" element={<DraftTeamPageMake />} />
        </Route>

        <Route path="/:lang/tool/survey" element={<HomeLayout />}>
          <Route path="" element={<ToolSurveyPageIndex />} />
          <Route path="campaigns/:campaign_id/results" element={<ToolSurveyPageResult />} />
          <Route path="campaigns/:campaign_id" element={<ToolSurveyPageShow />} />
          <Route path="ninth-age/units/:unit_id" element={<ToolSurveyUnitPageMake />} />
        </Route>

        <Route path="/:lang/publication/books" element={<HomeLayout />}>
          <Route path="" element={<PublicationBookPageIndex />} />
          <Route path="armies/new" element={<PublicationArmyBookPageNew />} />
          <Route path="armies/:army_id" element={<PublicationArmyBookPageMake />} />
          <Route path="/:lang/publication/books/:book_id" element={<PublicationBookPageMake />} />
        </Route>

        <Route path="/:lang/federation/clubs" element={<HomeLayout />}>
          <Route path="" element={<FederationClubPageIndex />} />
        </Route>

        <Route path="/:lang/ninth-age/table/maps" element={<HomeLayout />}>
          <Route path="" element={<MapPageIndex />} />
          <Route path=":map_id" element={<MapPageShow />} />
        </Route>

        <Route path="*" element={<Navigate to="/en/builder/army_lists" replace />}></Route>
      </SentryRoutes>
    </BrowserRouter>
  );
};

export default AppRouter;
